import React from "react";
import Hero from "../Hero";
import Roadmap from "./Section/Roadmap";
import Tokenomics from "../Tokenomics";
import Timeline from "../Timeline";
import Join from "../Join";
import Faqs from "../Faqs";
import Header from "../layouts/Header";
import DotCursor from "../DotCursor";
// import Motion from "./Motion";
const Home = () => {
  return (
    <>
      <DotCursor />
      <div className="bg-hero">
        <Header />
        <Hero />
      </div>
      <Tokenomics />
      {/* <Roadmap /> */}
      {/* <Motion /> */}
      <Timeline />
      <Faqs />
      <Join />
    </>
  );
};

export default Home;
